/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
const ManagementChartsView = () => import('./Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/management-charts'),
    name: 'management_charts',
    meta: {
      permissions: ['administrator'],
    },
    component: ManagementChartsView,
  },
  {
    path: frontendURL('accounts/:accountId/management-charts/schedules'),
    name: 'schedule_analytics',
    meta: {
      permissions: ['administrator'],
    },
    component: ManagementChartsView,
  },
];

export const publicRoutes = [
  {
    path: '/public/analytics/:token',
    name: 'public_management_charts',
    meta: {
      public: true,
      permissions: [],
    },
    component: ManagementChartsView,
  },
  {
    path: '/public/analytics/:token/schedules',
    name: 'public_schedule_analytics',
    meta: {
      public: true,
      permissions: [],
    },
    component: ManagementChartsView,
  },
];
